export enum WorldpayStatus {
  AlreadyProcessed = 'already_processed',
  Cancelled = 'cancelled_by_shopper',
  Error = 'error',
  Exception = 'exception',
  Failure = 'failure',
  Pending = 'pending',
  SessionExpired = 'session_expired',
  Success = 'success',
}
